// extracted by mini-css-extract-plugin
export default {"accordion":"BulletedStep_accordion__sjdd8","open":"BulletedStep_open__1n-eI","inner":"BulletedStep_inner__c0oAv"};